/**
 * Created by jiachenpan on 16/11/18.
 */
import {
  Message
} from 'element-ui'
import commonListApis from '@/api/commonPage/commonList'

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  if (arguments[0] == null) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (time == '0001-01-01T00:00:00') {
    return null
  }
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) {
      time = parseInt(time) * 1000
    } else {
      if (typeof (time) !== 'number' && time !== '0001-01-01T00:00:00') {
        time = time.replace(/T/g, ' ')
      }
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/gi) != null) {
      len += 1
    } else {
      len += 0.5
    }
  }
  return Math.floor(len)
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"') +
    '"}'
  )
}

// 获取本年度的第一周对应的周一
export function formattedDate() {
  // 创建一个表示今天的 Date 对象
  const today = new Date()
  // 获取今年的年份
  const year = today.getFullYear()
  // 创建一个表示本年1月1日的 Date 对象
  const firstDayOfYear = new Date(year, 0, 1)
  // 计算本年1月1日是星期几（0 表示星期日，1 表示星期一，以此类推）
  const firstDayOfWeek = firstDayOfYear.getDay()
  // 计算本年的第一个周一是几月几日
  const firstMondayOfYear = new Date(year, 0, 1 + (8 - firstDayOfWeek) % 7)
  // 将日期转换为中国标准时间格式的字符串（例如：Mon Jan 02 2023 00:00:00 GMT+0800 (中国标准时间)）
  const formattedDate = firstMondayOfYear.toDateString() + ' ' + firstMondayOfYear.toLocaleTimeString('en-US', {
    timeZone: 'Asia/Shanghai'
  })
  // 输出结果
  return formattedDate
}
export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [{
  text: '今天',
  onClick(picker) {
    const end = new Date()
    const start = new Date(new Date().toDateString())
    end.setTime(start.getTime())
    picker.$emit('pick', [start, end])
  }
},
{
  text: '最近一周',
  onClick(picker) {
    const end = new Date(new Date().toDateString())
    const start = new Date()
    start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
    picker.$emit('pick', [start, end])
  }
},
{
  text: '最近一个月',
  onClick(picker) {
    const end = new Date(new Date().toDateString())
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    picker.$emit('pick', [start, end])
  }
},
{
  text: '最近三个月',
  onClick(picker) {
    const end = new Date(new Date().toDateString())
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
    picker.$emit('pick', [start, end])
  }
}
]

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

export function amountFormat(s, type) {
  // if (/[^0-9\.]/.test(s))
  //   return "0";
  if (s >= 0) {
    if (s == null || s == '') {
      return '0'
    }
    s = s.toString().replace(/^(\d*)$/, '$1.')
    s = (s + '00').replace(/(\d*\.\d\d)\d*/, '$1')
    s = s.replace('.', ',')
    var re = /(\d)(\d{3},)/
    while (re.test(s)) {
      s = s.replace(re, '$1,$2')
    }
    s = s.replace(/,(\d\d)$/, '.$1')
    if (type == 0) { // 不带小数位(默认是有小数位)
      var a = s.split('.')
      if (a[1] == '00') {
        s = a[0]
      }
    }
    return s
  } else {
    s = -s
    if (s == null || s == '') {
      return '0'
    }
    s = s.toString().replace(/^(\d*)$/, '$1.')
    s = (s + '00').replace(/(\d*\.\d\d)\d*/, '$1')
    s = s.replace('.', ',')
    var re = /(\d)(\d{3},)/
    while (re.test(s)) {
      s = s.replace(re, '$1,$2')
    }
    s = s.replace(/,(\d\d)$/, '.$1')
    if (type == 0) { // 不带小数位(默认是有小数位)
      var a = s.split('.')
      if (a[1] == '00') {
        s = a[0]
      }
    }
    return '-' + s
  }
}

export function amountFormatForSix(num) {
  if (num) {
    return number_format(num, 6)
  } else {
    return '0.000000'
  }
}

export function amountFormatForTwo(num) {
  if (num) {
    return number_format(num, 2)
  } else {
    return '0.00'
  }
}

/**
 * [number_format 参数说明：]
 * @param  {[type]} number        [number：要格式化的数字]
 * @param  {[type]} decimals      [decimals：保留几位小数,默认2]
 * @param  {[type]} dec_point     [dec_point：小数点符号]
 * @param  {[type]} thousands_sep [thousands_sep：千分位符号]
 * @param  {[type]} roundtag      [roundtag:舍入参数，默认"round" 四舍五入, "ceil" 向上取,"floor"向下取]
 * @return {[type]}               [description]
 *
 */
export function number_format(number, decimals, dec_point, thousands_sep, roundtag) {
  number = (number + '').replace(/[^0-9+-Ee.]/g, '')
  roundtag = roundtag || 'round' // "ceil","floor","round"
  var n = !isFinite(+number) ? 0 : +number
  var prec = !isFinite(+decimals) ? 2 : Math.abs(decimals)
  var sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep
  var dec = (typeof dec_point === 'undefined') ? '.' : dec_point
  var s = ''
  var toFixedFix = function(n, prec) {
    var k = Math.pow(10, prec)
    // 先进行精确舍入，再使用 toFixed 保证返回十进制字符串，避免科学计数法
    var rounded = Math[roundtag](parseFloat((n * k).toFixed(prec * 2)))
    return (rounded / k).toFixed(prec)
  }
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  var re = /(-?\d+)(\d{3})/

  if (sep) {
    while (re.test(s[0])) {
      s[0] = s[0].replace(re, '$1' + sep + '$2')
    }
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  return s.join(dec)
}

/**
 * [number_format 参数说明：]
 * @param  {[type]} number        [number：要格式化的数字]
 * @param  {[type]} decimals      [decimals：保留几位小数,默认2]
 * @param  {[type]} dec_point     [dec_point：小数点符号]
 * @param  {[type]} thousands_sep [thousands_sep：千分位符号]
 * @param  {[type]} roundtag      [roundtag:舍入参数，默认"round" 四舍五入, "ceil" 向上取,"floor"向下取]
 * @param  {[type]} nojoin        [nojoin:是否补零 默认补零]
 * @return {[type]}               [description]
 *
 */
export function numberFormat(obj) {
  let {
    number,
    decimals,
    dec_point = '.',
    thousands_sep = ',',
    roundtag,
    nojoin = true
  } = obj

  number = (number + '').replace(/[^0-9+-Ee.]/g, '')
  roundtag = roundtag || 'round' // "ceil","floor","round"
  var n = !isFinite(+number) ? 0 : +number
  var prec = !isFinite(+decimals) ? 2 : Math.abs(decimals)
  var sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep
  var dec = (typeof dec_point === 'undefined') ? '.' : dec_point
  var s = ''
  var toFixedFix = function(n, prec) {
    var k = Math.pow(10, prec)
    // 先进行精确舍入，再使用 toFixed 保证返回十进制字符串，避免科学计数法
    var rounded = Math[roundtag](parseFloat((n * k).toFixed(prec * 2)))
    return (rounded / k).toFixed(prec)
  }
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  var re = /(-?\d+)(\d{3})/

  if (sep) {
    while (re.test(s[0])) {
      s[0] = s[0].replace(re, '$1' + sep + '$2')
    }
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    nojoin && (s[1] += new Array(prec - s[1].length + 1).join('0'))
  }
  return s.join(dec)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}
/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}
/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}
/**
 * 精度计算加法
 * @param {HTMLElement} val
 * 事例:addClac(0.1, 0.2, 0.3, 0.4) => 1。可以传多个参数进行相加。
 */
export function addClac(...val) {
  let max = 0
  let count = 0
  for (let i = 0; i < val.length; i++) {
    const strVal = val[i].toString()
    const index = strVal.indexOf('.')
    let num = 0
    if (index > -1) {
      num = strVal.length - 1 - index
      max = num > max ? num : max
    }
  }
  for (let i = 0; i < val.length; i++) {
    count += Math.round(val[i] * Math.pow(10, max))
  }
  return count / Math.pow(10, max)
}
/**
 * 精度计算减法
 * @param {HTMLElement} val
 * 事例:subClac(1, 0.2,) => 0.8。相当于1 - 0.2；使用首位减后面的参数。
 */
export function subClac(arg1, arg2) {
  var r1, r2, m, n
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  // 动态控制精度长度
  n = (r1 >= r2) ? r1 : r2
  return ((arg1 * m - arg2 * m) / m).toFixed(n)
}
/**
 * 精度计算乘法
 * @param {HTMLElement} val
 * 事例:rideClac(0.5, 0.6) => 3, 只允许传入两个参数。%计算可以这样ride(0.5, 100) => 50。
 */
export function rideClac(...val) {
  const strVal = val[0].toString()
  const strValTwo = val[1].toString()
  const index = strVal.indexOf('.')
  const indexTwo = strValTwo.indexOf('.')
  const num = [0, 0]
  if (index > -1) {
    num[0] = strVal.length - 1 - index
  }
  if (indexTwo > -1) {
    num[1] = strValTwo.length - 1 - index
  }
  return Math.round((val[0] * Math.pow(10, num[0])) * (val[1] * Math.pow(10, num[1]))) / Math.pow(10, num[0] + num[1])
}
/**
 * 精度计算除法
 * @param {HTMLElement} val
 * 事例:excClac(0.5, 0.2) => 2.5, 只允许传入两个参数。如果计算出现无穷数请后期根据需要修改最后代码进行取舍。
 */
export function excClac(val, valTwo = 100) {
  const strVal = val.toString()
  const strValTwo = valTwo.toString()
  const index = strVal.indexOf('.')
  const indexTwo = strValTwo.indexOf('.')
  const num = [0, 0]
  if (index > -1) {
    num[0] = strVal.length - 1 - index
  }
  if (indexTwo > -1) {
    num[1] = strValTwo.length - 1 - index
  }
  return Math.round(val * Math.pow(10, num[0])) / (Math.round((valTwo * Math.pow(10, num[1]))) * Math.pow(10, num[0] - num[1]))
}

/**
 * 验证对象 值 或者数组为空
 * @param {*} obj 传入验证的数据 可递归
 */
export function validateIsEmpty(obj) {
  // 检验null和undefined
  if (!obj && obj !== 0 && obj !== '') {
    return true
  }
  // 检验数组
  if (Array.prototype.isPrototypeOf(obj) && obj.length === 0) {
    return true
  }
  // 检验对象
  if (Object.prototype.isPrototypeOf(obj) && Object.keys(obj).length === 0) {
    return true
  }
  return false
}

/**
 * @description: 金额正则限制 只能输入整数 或者小数点后两位
 * @param {type}
 * @return {type}
 */
export function moneyLimitRule(num, limitNum = 2) {
  var str = num
  var len1 = str.substr(0, 1)
  var len2 = str.substr(1, 1)
  const reg = new RegExp('^(\\-)*(\\d+)\\.(\\d{0,' + limitNum + '}).*$', 'g')

  // 如果第一位是0，第二位不是点，就用数字把点替换掉
  if (str.length > 1 && len1 == 0 && len2 != '.') {
    str = str.substr(1, 1)
  }
  // 第一位不能是.
  if (len1 == '.') {
    str = ''
  }
  // 限制只能输入一个小数点
  if (str.indexOf('.') != -1) {
    var str_ = str.substr(str.indexOf('.') + 1)
    if (str_.indexOf('.') != -1) {
      str = str.substr(0, str.indexOf('.') + str_.indexOf('.') + 1)
    }
  }
  // 正则替换
  str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
  str = str.replace(reg, '$1$2.$3') // 小数点后只能输两位
  return str
}

/**
 * @description: 判断变量类型
 * @param {*} data 变量数据
 * @param {*} type 类型
 * @return {*}
 */
export function determineVariableType(data, type) {
  var toString = Object.prototype.toString
  var dataType = toString
    .call(data)
    .replace(/\[object\s(.+)\]/, '$1')
    .toLowerCase()
  return dataType === type.toLowerCase()
}

/**
 * @description: 广播事件
 * @param {*} componentName componentName 组件名称
 * @param {*} eventName 事件名称
 * @param {*} params 参数
 * @return {*}
 */
function _emit_broadcast(componentName, eventName, params) {
  this.$children.forEach(child => {
    var name = child.$options.name
    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params))
    } else {
      _emit_broadcast.apply(child, [componentName, eventName].concat([params]))
    }
  })
}

export function emit_broadcast(componentName, eventName, params) {
  _emit_broadcast.call(this, componentName, eventName, params)
}

/**
 * @description: 派发事件 适合组件内部
 * @param {*} componentName
 * @param {*} eventName
 * @param {*} params
 * @return {*}
 */
function _emit_dispatch(componentName, eventName, params) {
  var parent = this.$parent || this.$root
  var name = parent.$options.name
  while (parent && (!name || name !== componentName)) {
    parent = parent.$parent
    if (parent) {
      name = parent.$options.name
    }
  }
  if (parent) {
    parent.$emit.apply(parent, [eventName].concat(params))
  }
}

export function emit_dispatch(componentName, eventName, params) {
  _emit_dispatch.call(this, componentName, eventName, params)
}

// 数字转为中文大写
export function digitUppercase(number) {
  var ret = '零'
  if (number != '' && number != null && number != 0) {
    var unit = '仟佰拾亿仟佰拾万仟佰拾元角分'
    let str = ''
    number += '00'
    var point = number.indexOf('.')
    if (point >= 0) {
      number = number.substring(0, point) + number.substr(point + 1, 2)
    }
    unit = unit.substr(unit.length - number.length)
    for (var i = 0; i < number.length; i++) {
      str +=
        '零壹贰叁肆伍陆柒捌玖'.charAt(number.charAt(i)) + unit.charAt(i)
    }
    ret =
      str
        .replace(/零(仟|佰|拾|角)/g, '零')
        .replace(/(零)+/g, '零')
        .replace(/零(万|亿|元)/g, '$1')
        .replace(/(亿)万|(拾)/g, '$1$2')
        .replace(/^元零?|零分/g, '')
        .replace(/元$/g, '元') + '整'
  }
  return ret
}

/**
 * todo: 需要考虑大数据 对比层数比较深等情况
 * @description: 比对新旧json 返回其中变化的数据 进行深层对比
 * @param {Object|Array} oldJson 老json 对比数据源
 * @param {Object|Array} newJson 新json 被对比数据源
 * @return {Array} 返回变化的json对象 [<object>]
 */
export function diffJson(oldJson, newJson) {
  // if(!oldJson||!newJson||isEmptyObject(oldJson)||isEmptyObject(newJson)) {
  //   return null
  // }

  const oldJsonLen = oldJson.length
  const newJsonLen = newJson.length
  const result = []
  // 对比数据为空 证明是新增数据
  if (oldJsonLen <= 0) {
    return newJson
  }

  for (let i = 0; i < newJsonLen; i++) {
    const newJsonObj = newJson[i]
  }
}

/**
 * @description: 获取数据对象的类型 array object
 * @param {*} data
 * @return {*}
 */
function getTypeByData(data) {
  return Object.prototype.toString.call(data).match(/^\[object ([a-zA-Z]*)\]$/)[1]
}

/**
 * @description: 判断是否是空对象
 * @param {*} arr
 * @return {*}
 */
function isEmptyObject(arr) {
  for (var key in obj) {
    return false
  }
  return true
}
/**
 * [changeType 参数说明：]
 * @param  {[type]} row              [row：当前行数据]
 * @param  {[type]} data_list        [data_list：转化对比数据]
 * @param  {[type]} source_code [source_code_list：code参数]
 * @param  {[type]} return_name_list [return_name_list：返回name数组,默认name]
 *
 */
export function changeType(row, data_list, source_code, return_name_list) {
  if (!row || !data_list || !source_code) return
  const changeTypeList = []
  data_list.forEach(element => {
    if (row[source_code] == element.value) {
      if (!return_name_list) {
        changeTypeList.push(element.name)
      } else {
        return_name_list.forEach(index => {
          changeTypeList.push(element[index])
        })
      }
    }
  })
  return changeTypeList
}

/**
 * @description: 判断pc 还是移动端
 * @param {*}
 * @return {*}
 */
export function isMobilePlatform(row) {
  const sUserAgent = navigator.userAgent.toLowerCase()
  const bIsIpad = sUserAgent.match(/ipad/i) == 'ipad'
  const bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os'
  const bIsMidp = sUserAgent.match(/midp/i) == 'midp'
  const bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4'
  const bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb'
  const bIsAndroid = sUserAgent.match(/android/i) == 'android'
  const bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce'
  const bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile'
  if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
    return true // 移动设备
  } else {
    return false // PC
  }
}

/**
 * @description: 生成全局uuid
 * @param {*} len 长度
 * @param {*} radix 基数
 * @return {*}
 */
export function createUuid(len, radix) {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  var uuid = []
  var i
  radix = radix || chars.length

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
  } else {
    // rfc4122, version 4 form
    var r

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16
        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r]
      }
    }
  }

  return uuid.join('')
}

/**
 * @description: 可选链操作
 * @param {String} content
 * @return {*}
 */
export function optionsChain(content) {
  // return content.replace(new RegExp(/([\$_\w\.]+\?\.)/, 'g'), function(res) {
  const str = content.replace(/[\$|\?\.]/, '')
  const arrs = str.split('.')
  const strArr = []
  for (let i = 1; i <= arrs.length; i++) {
    strArr.push(arrs.slice(0, i).join('.'))
  }
  const compile = strArr.join('&&')
  const done = compile + '&&' + str + '.'
  return compile
  // })
}
/**
 * @description: 从响应头中获取文件名称
 * @param {*} res
 * @return {*}
 */
export function exportBlob(res) {
  const blob = new Blob([res.data])
  blob.text().then(result => {
    try {
      const jsonData = JSON.parse(result)
      if (jsonData.res_status_code && jsonData.res_message) {
        Message({
          message: jsonData.res_message,
          type: 'error',
          duration: 5 * 1000
        })
      } else {
        Message({
          message: '系统异常',
          type: 'error',
          duration: 5 * 1000
        })
      }
    } catch (e) {
      const disposition = decodeURI(res.headers['content-disposition'])
      // 从响应头中获取文件名称
      const fileName = disposition.substring(disposition.indexOf('filename*=') + 17, disposition.length)
      if ('download' in document.createElement('a')) {
        // 非IE下载
        const elink = document.createElement('a')
        elink.download = fileName || '文件出错'
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink)
      } else {
        // IE10+下载
        navigator.msSaveBlob(blob, fileName)
      }
    }
  })
}

/**
 * @description: 区分中英文
 * @param {*} str
 * @return {*}
 */
export function getStrLength(str) {
  let len = 0
  for (let i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
      len += 2
    } else {
      len++
    }
  }
  return len
}

/**
 * @description: 表格底部合计方法
 * @param {*} columns 列配置
 * @param {*} dataList 数据列表
 * @param {*} fieldList 字段列表
 * @return {*} 合计列表
 */
export function commonSumMethod(
  columns,
  dataList,
  fieldList
) {
  // 如果关键参数为空，则返回 false
  if (!fieldList || !dataList || !columns) {
    return false
  }

  // 辅助函数：安全地将包含千位符的字符串转换为数字
  const parseNumber = (value) => {
    if (value == null || value === '') {
      return 0
    }
    // 如果是数字类型，直接返回
    if (typeof value === 'number') {
      return isNaN(value) ? 0 : value
    }
    // 如果是字符串，先去除千位符（逗号），再转换为数字
    if (typeof value === 'string') {
      const cleanedValue = value.replace(/,/g, '')
      const num = Number(cleanedValue)
      return isNaN(num) ? 0 : num
    }
    // 其他类型尝试直接转换
    const num = Number(value)
    return isNaN(num) ? 0 : num
  }
  // 过滤需要合计并且是数字类型的列，并构建包含属性、小数位和合计值的对象数组
  const filterNeedSumList = fieldList.filter(el => (/int|number/.test(el.field_type)) && el.is_sum === 1).map(el => ({
    property: el.field_code,
    decimals: el.field_type === 'int' ? 0 : (Number(el.field_type.slice(-1)) ? el.field_type.slice(-1) : 2),
    numberSum: sumAddClac(dataList.map(item => parseNumber(item[el.field_code])))
  }))
  const sums = [] // 用于保存合计值的数组
  // 遍历每个列，将对应的合计值赋给 sums 数组
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = '合计'
      return
    }
    // 查找与当前列属性匹配的合计信息
    const matchingSum = filterNeedSumList.find(el => column.property === el.property)
    sums[index] = matchingSum ? number_format(matchingSum.numberSum, matchingSum.decimals) : undefined
  })

  return sums // 返回合计值数组
}

export function sumAddClac(val) {
  return val.reduce((prev, curr) => {
    const value = Number(curr)
    if (!isNaN(value)) {
      return addClac(prev, curr)
    } else {
      return prev
    }
  }, 0)
}

/**
 * @description: 将字符串转为json对象
 * @param {*}
 * @return {*}
 */
export function convertStringToObj(str) {
  // 此处使用try catch 防止 json.parse 报错 导致程序出错
  try {
    return str && typeof str === 'string' ? eval('(' + str + ')') : {}
  } catch (error) {
    return {}
  }
}

/**
 * @description: 上一个月的月份
 * @param {*}
 * @return {*}
 */
export function getPreviousMonth() {
  const currentDate = new Date() // 获取当前时间
  const year = currentDate.getFullYear()
  let month = currentDate.getMonth() + 1 // 获取当前月份，并加1

  // 如果当前月份是1月，则上一个月是去年的12月
  if (month === 1) {
    return `${year - 1}-12` // 返回上一个月的年份和月份
  } else {
    month-- // 减去1个月
    // 如果月份是个位数，在前面添加0
    const formattedMonth = month < 10 ? `0${month}` : month
    return `${year}-${formattedMonth}` // 返回上一个月的年份和月份
  }
}

/**
   * @description: el-input 文本框校验小数位数
   * @param {Boolean} value - 需要校验的值
   * @param {string} decimalPlaces - 默认校验2位小数， 0 整数  3 三位小数
   */
export function handleInput(value, decimalPlaces = 2) {
  // 如果限制为整数，移除所有非数字字符
  if (Number(decimalPlaces) === 0) {
    return value.replace(/\D/g, '')
  }
  // 移除所有非数字和非小数点的字符
  value = value.replace(/[^\d.]/g, '')
  // 如果第一个字符是小数点，则删除它
  if (value.startsWith('.')) {
    value = value.substr(1)
  }
  // 分割整数和小数部分
  const parts = value.split('.')
  // 如果存在小数点，限制小数部分的位数
  if (parts.length > 1) {
    parts[1] = parts[1].substring(0, decimalPlaces)
    value = parts[0] + '.' + parts[1]
  }
  return value
}

// 定义一个函数，接受 list 和 value 作为参数
export function getNameByValue(list, value, key, name) {
  // 使用 find 方法查找第一个匹配的元素
  const item = list.find(item => item[key] === value)
  // 如果找到了元素，返回其 name，否则返回 undefined
  return item ? item[name] : undefined
}

/**
 * @description: 日期处理 - 统一的日期动态配置函数
 * @author domiyong
 * @param {number|string} count 日期参数
 * @return {string} 格式化后的日期字符串 yyyy-MM-dd
 *
 * 用法说明：
 * 数字参数：
 *   - getDateprocessing(0)   // 今天
 *   - getDateprocessing(1)   // 昨天
 *   - getDateprocessing(30)  // 30天前
 *   - getDateprocessing(90)  // 90天前
 *
 * 特殊字符串参数：
 *   - getDateprocessing('month_first')  // 当月1号
 *
 * JSON配置中的用法：
 *   基础用法：
 *     "value": "getDateprocessing(0)"              // 今天
 *     "value": "getDateprocessing('month_first')"  // 当月1号
 *
 *   复杂时间格式：
 *     "value": "${getDateprocessing(0)} 23:59:59"              // 今天 23:59:59
 *     "value": "${getDateprocessing('month_first')} 00:00:00"  // 当月1号 00:00:00
 */
export function getDateprocessing(count) {
  const date = new Date()

  // 特殊处理：当月1号
  if (count === 'month_first') {
    const year = date.getFullYear()
    const month = date.getMonth()
    const firstDay = new Date(year, month, 1)
    return parseTime(firstDay, '{y}-{m}-{d}')
  }

  // 原有逻辑：按天数计算
  date.setDate(date.getDate() - count)
  return parseTime(date, '{y}-{m}-{d}')
}

/**
 * @description: 获取当前月份第一天
 * @author domiyong
 * @param {string} format 日期格式，默认 '{y}-{m}-{d}'
 * @returns {string} 格式化后的日期字符串
 */
export function getCurrentMonthFirst(format = '{y}-{m}-{d}') {
  const date = new Date()
  // Node.js 14.x 兼容写法：不使用可选链
  const year = date.getFullYear()
  const month = date.getMonth()
  const firstDay = new Date(year, month, 1)

  return parseTime(firstDay, format)
}

/**
 * @description: 获取今天日期（标准化当天获取）
 * @author domiyong
 * @param {string} format 日期格式，默认 '{y}-{m}-{d}'
 * @returns {string} 格式化后的日期字符串
 */
export function getToday(format = '{y}-{m}-{d}') {
  const date = new Date()
  return parseTime(date, format)
}

/**
 * @description: 动态日期标记枚举
 * @author domiyong
 */
export const DATE_DYNAMIC_MARKERS = {
  CURRENT_MONTH_FIRST: '@CURRENT_MONTH_FIRST@', // 当月1号
  TODAY: '@TODAY@', // 当天
  YESTERDAY: '@YESTERDAY@' // 昨天
}

/**
 * @description: 解析动态日期标记（Node.js 14.x兼容）
 * @author domiyong
 * @param {string} dateValue 日期值，可能包含特殊标记
 * @param {string} format 日期格式，默认 '{y}-{m}-{d}'
 * @returns {string} 解析后的真实日期
 */
export function resolveDynamicDateValue(dateValue, format = '{y}-{m}-{d}') {
  // Node.js 14.x 兼容：使用传统判断而非可选链
  if (!dateValue || typeof dateValue !== 'string') {
    return dateValue
  }

  // 解析特殊标记
  switch (dateValue) {
  case DATE_DYNAMIC_MARKERS.CURRENT_MONTH_FIRST:
    return getCurrentMonthFirst(format)
  case DATE_DYNAMIC_MARKERS.TODAY:
    return getToday(format)
  case DATE_DYNAMIC_MARKERS.YESTERDAY:
    return getDateprocessing(1) // 使用现有方法：昨天
  default:
    // 处理函数调用：getDateprocessing(0)、getCurrentMonthFirst()
    if (dateValue.includes('getDateprocessing(')) {
      const match = dateValue.match(/getDateprocessing\((\d+)\)/)
      if (match) {
        const days = parseInt(match[1])
        const dateResult = getDateprocessing(days)
        return dateValue.replace('getDateprocessing(' + days + ')', dateResult)
      }
    } else if (dateValue.includes('getCurrentMonthFirst()')) {
      const dateResult = getCurrentMonthFirst(format)
      return dateValue.replace('getCurrentMonthFirst()', dateResult)
    } else if (dateValue.includes('getToday()')) {
      const dateResult = getToday(format)
      return dateValue.replace('getToday()', dateResult)
    }

    // 处理模板字符串：${getDateprocessing(0)} 23:59:59
    if (dateValue.includes('${')) {
      // Node.js 14.x 兼容：使用replace替代模板字符串
      let processedValue = dateValue
      processedValue = processedValue.replace(/\$\{([^}]+)\}/g, function(match, expr) {
        try {
          // 安全的函数调用解析
          if (expr.includes('getDateprocessing(')) {
            const funcMatch = expr.match(/getDateprocessing\((\d+)\)/)
            if (funcMatch) {
              return getDateprocessing(parseInt(funcMatch[1]))
            }
          } else if (expr === 'getCurrentMonthFirst()') {
            return getCurrentMonthFirst(format)
          } else if (expr === 'getToday()') {
            return getToday(format)
          } else if (expr === DATE_DYNAMIC_MARKERS.CURRENT_MONTH_FIRST) {
            return getCurrentMonthFirst(format)
          } else if (expr === DATE_DYNAMIC_MARKERS.TODAY) {
            return getToday(format)
          } else if (expr === DATE_DYNAMIC_MARKERS.YESTERDAY) {
            return getDateprocessing(1)
          }
          return match
        } catch (e) {
          console.warn('日期函数解析失败:', expr, e)
          return match
        }
      })
      return processedValue
    }

    return dateValue // 非特殊标记，返回原值
  }
}

/**
 * @description: 金额处理
 * @param {*} count 超出万元部分显示w 传入金额 小数位 金额符号
 * @return {*}
 */
export function getAmountProcessing(amount, decimal = 2, symbol = 'w') {
  if (amount >= 10000) {
    return `${number_format(amount / 10000, decimal)}${symbol}`
  } else {
    return `${number_format(amount, decimal)}`
  }
}

/**
 * @description: 百分比处理
 * @param {*} count 小数*100 并加入%  传入百分比 小数位
 * @return {*}
 */
export function getPercentageProcessing(percentage, decimal = 1) {
  return percentage ? `${(percentage * 100).toFixed(decimal)}%` : (percentage === 0 ? '0%' : '')
}

/**
 * @description: 获取商品品牌数据
 * @param {*} is_core 是否核心品牌  'Y' 核心品牌 'N' 非核心品牌
 * @return {*}
 */
export function getBrandData(is_core = 'Y') {
  const queryData = {
    DocModel: 'Brand',
    Query: {
      is_core
    },
    queryName: 'GetBrand',
    page_size: 99999,
    page_no: 1
  }
  const params = {
    module: 'erp',
    params: { ...queryData }
  }
  commonListApis.GetDocumentPageList({
    ...params
  }).then(res => {
    if (res.data.res_status_code === '0') {
      const data = res.data.res_content
      return data
    }
  })
}

/**
  * @description: 省市区拿到全部数据源之后组装成树形结构  只需要 省市区 三级
  * @param {*} data
  * @return {*}
  */
export function organizeRegions(data) {
  // 先按照 region_id 将所有区域组织为一个 map，便于后续查找
  const regionMap = new Map()
  data.forEach((item) => {
    regionMap.set(item.region_id, item)
  })

  // 创建树形结构
  const tree = []

  // 遍历数据，根据 region_level 和 parent_id 组织成树形结构
  data.forEach((item) => {
    // 跳过 region_level 为 4 的节点
    if (item.region_level === 4) {
      return
    }

    if (item.region_level === 1) {
      // region_level 为 1 的项直接作为顶级节点加入树形结构
      tree.push(item)
    } else {
      // 找到对应的父级节点并将当前节点加入父级的 children_list
      const parent = regionMap.get(item.parent_id)
      if (parent) {
        parent.children_list = parent.children_list || []
        parent.children_list.push(item)
      }
    }
  })

  return tree
}

export function editRoute(currentRoute, newId) {
  // eslint-disable-next-line one-var
  const route = Object.assign({}, currentRoute),
    linkStr = 'id=' + route.query.id,
    link = route.fullPath.replace(linkStr, 'id=' + newId)

  route.query = {
    backPath: route.query.backPath,
    type: route.query.type,
    id: newId,
    parent_t: route.query.parent_t,
    t: route.query.t
  }
  window.history.pushState({}, '', '/#' + link)
  route.fullPath = link
  return route
}

/**
     * @description: 将含有冒号的信息 转成字符串拼接的信息
     * @param {*}
     * @return {*}
     */
export function convertAddress(data) {
  let address = ''
  let phone = ''
  let name = ''
  let quKey = ''
  let detailAddressKey = ''
  const obj = data.split(/[\n]/).reduce((pre, cur) => {
    const arr = cur.split(':')
    const key = arr[0]
    const val = arr[1]
    pre[key] = val.trim()
    return pre
  }, {})
  for (const key in obj) {
    if (key.indexOf('人') >= 0 || key.indexOf('名') >= 0) {
      name = obj[key]
    } else if (key.indexOf('号') >= 0 || key.indexOf('机') >= 0) {
      phone = obj[key]
    } else if (key.indexOf('区') >= 0) {
      quKey = key
    } else if (key.indexOf('址') >= 0) {
      detailAddressKey = key
    }
    if (Object.keys(obj).length > 3) {
      address = obj[quKey] + obj[detailAddressKey]
    } else {
      address = obj[quKey] || obj[detailAddressKey]
    }
  }

  return `${address},${name},${phone}`
}
